import { bindNot, isBoolean } from 'vest-utils';

export const isNotBoolean = bindNot(isBoolean);
export { isBoolean };
